module.exports = __webpack_public_path__ + "img/content-1.3b9450cb.png";